<template>
  <div class="topRouge" id="panneauxLc" v-if="detailPanneauxLcFilter.length">
    <p class="p_size18 has-text-weight-bold has-text-link bottomVert">
      <b-icon
        icon="circle"
        size="is-small"
        class="circleStyleMobile">
      </b-icon>
      Proposition face(s) LC
    </p>
    <div>
      <app-carte-panneaux-lc :markers="detailPanneauxLcFilter" :markerFaceLc="markerFaceLc"/>
    </div>
    <p class="p_size14 has-text-weight-bold has-text-link bottomViolet topVert">
      Liste face(s) LC
    </p>
    <app-listes-faces-lc :detailPanneauxLc="detailPanneauxLcFilter"/>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import cartePanneauxLc from './cartePanneauxLc';
import listesFacesLc from './listesFacesLc';

export default {
  name: 'index',
  props: ['detailPanneauxLc', 'adresseFaceLc'],
  components: {
    appCartePanneauxLc: cartePanneauxLc,
    appListesFacesLc: listesFacesLc,
  },
  data() {
    return {
      markerFaceLc: {},
    };
  },
  computed: {
    detailPanneauxLcFilter() {
      return this.detailPanneauxLc.filter(d => !d.extensionOpportunite.reseauPersoGuid);
    },
  },
  methods: {
    generateMarkerFaceLc() {
      if (this.adresseFaceLc.lat !== undefined) {
        this.markerFaceLc = {
          ...this.adresseFaceLc,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarkerFaceLc();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxLc/index.vue